import React, { useState, useEffect } from 'react';
import {isAuthenticated} from "../../store/action/auth";
import axios from "axios";
import {API} from "../../config";
import AdminPostalCodeTable from "../../components/tables/AdminPostalCodeTable";

const PostalCodeCorrector = () => {
    const { token } = isAuthenticated();
    const [ loading, setLoading ] = useState(true);
    const [ postalCodes, setPostalCodes ] = useState([]);
    const [ values, setValues ] = useState({
        falsePostalCode:'',
        correctPostalCode:''
    });


    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        try {
            const res = await axios.get(`${API}/v1/admin/correctors/postal_codes`, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });
            if(res.data.success) {
                const postalCodes = res.data.postal_codes.reduce((r,i)=>{
                    r.push({
                        id: i.id,
                        wrongPostalCode:i.false_postal_code,
                        correctPostalCode: i.correct_postal_code
                    });
                    return r
                },[]);
                setPostalCodes(postalCodes)
            } else {
                alert(res.data.error)
            }
        } catch (e) {
            console.log (e);
            alert(e.message)
        }
        setLoading(false)
    };

    const onAddPostalCode = async () => {
        try {
            let data = {
                false_postal_code:values.falsePostalCode,
                correct_postal_code:values.correctPostalCode,
            };
            const res = await axios.post(`${API}/v1/admin/correctors/postal_codes`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });
            if(res.data.success) {
                alert(res.data.message);
                window.location.reload()
            } else {
                alert(res.data.error);
            }
        } catch (e) {
            console.log (e);
            return alert(e.response.data.error)
        }
    };

    const onChange = name => e => {
        const value = e.target.value;
        setValues({
            ...values,
            [name]: value
        });
    };


    return (
        <div className="bg-white rounded shadow">
            <div className="p-4 d-flex justify-content-between">
                <h5>List Semua User</h5>
            </div>
            <div className="px-3 pb-4 row justify-content-center align-items-center">
                <div className="col-4 input-group-sm">
                    <input
                        type="text"
                        onChange={onChange('falsePostalCode')}
                        placeholder="Kode Pos Salah"
                        className="form-control "
                        value={values.falsePostalCode}
                        required
                    />
                </div>
                <div className="col-4 input-group-sm">
                    <input
                        type="text"
                        onChange={onChange('correctPostalCode')}
                        placeholder="Kode Pos Benar"
                        className="form-control "
                        value={values.correctPostalCode}
                        required
                    />
                </div>
                <div className="col-2 btn-group-sm">
                    <button
                        className="btn btn-sm btn-primary mr-3 btn-block"
                        onClick={onAddPostalCode}
                    >
                        Add
                    </button>
                </div>
            </div>
            <AdminPostalCodeTable
                data={postalCodes}
                loading={loading}
            />
        </div>
    )


};

export default PostalCodeCorrector;